







































import { defineComponent } from '@nuxtjs/composition-api';
import BaseHeading from '@shared/components/@atoms/BaseHeading/BaseHeading.vue';
import BaseImage from '@shared/components/@atoms/BaseImage/BaseImage.vue';
import UCSkeletonShimmer from '@shared/components/@atoms/UCSkeletonShimmer/UCSkeletonShimmer.vue';

export default defineComponent({
  name: 'UCProductHeading',
  components: {
    BaseImage,
    BaseHeading,
    UCSkeletonShimmer,
  },
  props: {
    productName: {
      type: String,
      required: true,
    },
    productNumber: {
      type: String,
      default: '',
    },
    brandLogo: {
      type: String,
      default: '',
    },
    brandLink: {
      type: String,
      default: '',
    },
    vendorName: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
});
